var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBolt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 22,
  fill: "currentColor",
  viewBox: "0 0 13 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.811 10.762a1 1 0 0 0-.802-1.597H6.882L9.554 0 1.19 11.238a1 1 0 0 0 .802 1.597h4.127L3.446 22z"
})));
export default SvgBolt;